// extracted by mini-css-extract-plugin
module.exports =  {"btn":"_0d624b9a27--btn--pDyoc","wrapper":"_0d624b9a27--wrapper--Rhr0U"};